import React from 'react'

export default function RadioButtonmovieswebseries(props) {
  const { inputData, handlecontentTypeChange } = props
  //
  return (
    <>
      <div className='d-flex space-between' style={{ gap: '10px' }}>
        <div className='d-flex'>
          <input
            type='radio'
            id='movies'
            name='movie'
            value='movies'
            checked={inputData.contentType === 'movies'}
            onChange={event => handlecontentTypeChange('contentType', event.target.value)}
          />
          <label htmlFor='movies' onClick={() => handlecontentTypeChange('contentType', 'movies')}>
            Movies
          </label>
        </div>
        <div className='d-flex'>
          <input
            type='radio'
            id='webseries'
            name='movie'
            value='webseries'
            checked={inputData.contentType === 'webseries'}
            onChange={event => handlecontentTypeChange('contentType', event.target.value)}
          />
          <label
            htmlFor='webseries'
            onClick={() => handlecontentTypeChange('contentType', 'webseries')}
          >
            Webseries
          </label>
        </div>
      </div>
      {inputData.contentType === '' && (
        <div className='mandatory1'>Please select atleast one of Movies or Webseries</div>
      )}
    </>
  )
}
